const UMMOConfig = {
  text: {
    UMMOHeading: "LIFT ROI",
    UMMODescription: "Providing actionable campaign insights to strengthen marketing and media decisions.",
    buttonText: "open",
  },
  products: [
    {
      key: "athena",
      name: "Athena",
      description: "Strategic optimisation of marketing mix on business performance",
      imageSrc: "/images/athena-image.png",
      link: () => {
        const split = window.location.href.split("#");
        if (split.length === 2) {
          return `${split[0]}athena/#${split[1]}`;
        } else {
          return `${split[0]}athena/`;
        }
      },
      accentColor: "#AA8A30",
    },
    {
      key: "hai",
      name: "Hamilton.AI",
      description: "Strategic and tactical optimisation of marketing mix on business performance",
      imageSrc: "/images/hai-image.png",
      link: () => {
        const split = window.location.href.split("#");
        const origin = window.location.origin
        if (split.length === 2) {
          return `${origin}/hai/#${split[1]}`;
        } else {
          return `${origin}/hai/`;
        }
      },
      accentColor: "#802AB5",
    },
  ],
};

export default UMMOConfig;
